import * as R from 'ramda';
import { AlternatePayeeList } from '../../../types';

const ALTERNATE_PAYEE_SCHEMA/*: Record<string, 'String' | 'Number'>*/ = {
  id: "Number",
  name: "String",
  paymentMethodId: "Number",
  paymentCurrency: "String",
  accountType: "String",
  routingNumber: "String",
  accountNumber: "String",
  payableTo: "String",
  finInstitutionName: "String",
  lastModified: "String"
} as const;

export { ALTERNATE_PAYEE_SCHEMA }

const isValidSchema = (alternatePayeeList: AlternatePayeeList, schema: any): boolean => {
  const getSchemaFn = R.map(R.map(R.type));
  const jsonSchema = getSchemaFn(alternatePayeeList);
  const baseSchema = R.repeat(schema, alternatePayeeList.length);
  return R.equals(jsonSchema, baseSchema);
};


export const validateAlternatePayee = (json: any): AlternatePayeeList => {
  const hasAlternatePayeesProp = R.has('alternatePayees')(json);

  if (!hasAlternatePayeesProp) {
    console.warn("The 'alternatePayees' property is not present in json response.");
    throw new Error('Something went wrong. Data has missing properties.');
  }

  const { alternatePayees } = json;

  const isValidAlternatePayee: boolean = isValidSchema(alternatePayees, ALTERNATE_PAYEE_SCHEMA);

  if (!isValidAlternatePayee) {
    console.warn("The json schema response is incorrect.");
    throw new Error('Something went wrong. Invalid schema.');
  }

  return alternatePayees as AlternatePayeeList;
};
